// React and related imports
import React from 'react';

// Flowbite components
import { Dropdown, Checkbox, Button } from 'flowbite-react';

// i18n hooks
import { useTranslation } from 'react-i18next';

// Lodash utility functions
import isEqual from 'lodash/isEqual';

// Interfaces and Enums
import { IAnswer } from '../../common/interfaces/Answer.interface';

// Redux hooks and selectors
import { useAppSelector } from '../../redux/hooks/useAppSelector';
import { selectIsDarkMode } from '../../redux/selectors/displaySettingsSelectors';

interface AnswersDropdownProps {
  answers: IAnswer[];
  selectedQuestionAnswer: IAnswer;
  setSelectedAnswer: (selected: IAnswer) => void;
}

export const AnswersDropdown: React.FC<AnswersDropdownProps> = ({
  answers,
  selectedQuestionAnswer,
  setSelectedAnswer,
}) => {
  const { t } = useTranslation();
  const isDarkMode = useAppSelector(selectIsDarkMode);

  return (
    <Dropdown
      className="h-2/5 overflow-y-scroll"
      dismissOnClick={false}
      arrowIcon={false}
      inline
      label={
        <Button
          size="sm"
          className={`btn flex w-40 items-center ${isDarkMode ? 'btn-dark' : 'btn-light'}`}
          as={'span'}
        >
          {t('content.chooseAnswer')}
        </Button>
      }
    >
      {answers.map(
        (answer, index) =>
          answer.dataSources && (
            <Dropdown.Item
              key={index}
              className={`flex items-center space-x-3 ${isEqual(answer, selectedQuestionAnswer) && 'bg-gray-100 dark:bg-gray-600'} `}
              onClick={() => setSelectedAnswer(answer)}
            >
              <Checkbox
                id={`answer-${index}`}
                checked={isEqual(answer, selectedQuestionAnswer)}
                onChange={() => setSelectedAnswer(answer)}
              />
              {answer.dataSources?.[0]?.options.map((option, index) => (
                <span
                  key={index}
                  className={`${option?.isCorrect ? 'text-green-400' : ''}`}
                >
                  {option?.value?.[0].value}
                </span>
              ))}
            </Dropdown.Item>
          )
      )}
    </Dropdown>
  );
};
